import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzInputModule } from 'ng-zorro-antd/input';
import { BaseComponent } from '../../../../shared/utils/base.component';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { CommonModule } from '@angular/common';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { RADIO_YES_NO_OPTIONS, STATIC_JSON_DATA_PATH } from '../../../../shared/constants/static-data.constants';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { SectionsService } from '../../../../services/sections.service';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { Router } from '@angular/router';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { AccordionComponent } from "../../../../shared/components/accordion/accordion.component";
import { AuthUtilizationComponent } from "../auth-utilization/auth-utilization.component";
import { AuthTimesheetsComponent } from "../auth-timesheets/auth-timesheets.component";
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { TableRowActionsModel } from '../../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../../shared/interfaces/actions';
import { GridAction } from '../../../../shared/components/list-table/grid-action.model';
import { AuthFormsComponent } from "../auth-forms/auth-forms.component";
import { PopupDialogComponent } from '../../../../shared/components/popup-dialog/popup-dialog.component';
import { AuthorizationsDetailsService } from '../../../../services/authorizations-service.service';
import { LookupService } from '../../../../services/lookup.service';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'ppl-add-authorization',
  standalone: true,
  imports: [
    ButtonComponent,
    NzFormModule,
    ReactiveFormsModule,
    FormsModule,
    NzCardModule,
    NzInputModule,
    NzToolTipModule,
    CommonModule,
    NzDatePickerModule,
    NzToolTipModule,
    NzSelectModule,
    NzButtonModule,
    NzCollapseModule,
    AccordionComponent,
    AuthFormsComponent,
    PopupDialogComponent
],
  templateUrl: './add-authorization.component.html',
  styleUrl: './add-authorization.component.css',
})
export class AddAuthorizationComponent extends BaseComponent implements OnInit {
  authorizationsForm!: FormGroup;
  radioOptions = RADIO_YES_NO_OPTIONS;
  providerTypes: any;
  pageTitle = 'Add Authorization';
  mode = 'edit';
  savedData: any = {};
  isNew = true;
  isParticipantSelected = false;
  isConsumerSelected = false;
  showConsumersList = false;
  programName!: string;
  columnsToBeHidden: any;
  sharedDataKey: any;
  actionsToBeHidden: any;
  lazyLoad = true;
  cols: any[] = [];
  flow: string|null = '';
  selectedConsumer: any;
  show = false;
  authAdded = false;
  diagnosisCodesList: any;

  actionButtons: TableRowActionsModel = new TableRowActions({ add: true });


  participants = [
    {
      lkpValueName: 'Manoj Kumar',
      lkpValueCode: 'm1',
    },
    {
      lkpValueName: 'Neha Dogra',
      lkpValueCode: 'm1',
    },
    {
      lkpValueName: 'Venkat N',
      lkpValueCode: 'm1',
    }
  ];

  providers = [
    {
      lkpValueName: 'Provider Manoj Kumar',
      lkpValueCode: 'm1',
    },
    {
      lkpValueName: 'Provider Neha Dogra',
      lkpValueCode: 'm1',
    },
    {
      lkpValueName: 'Provider Venkat N',
      lkpValueCode: 'm1',
    }
  ];

  gridData = [
    {
        consumerFirstName: 'Nikhil',
        consumerLastName: 'Peter',
        medicaid: 'PRV-NY-10000722',
        pplId: 'PPL-NY-10000733',

    },
    {
        consumerFirstName: 'Venkat',
        consumerLastName: 'Paul',
        medicaid: 'PRV-NY-10000745',
        pplId: 'PPL-NY-10000793',
    },
  ]

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private sectionsService: SectionsService,
    private authorizationService: AuthorizationsDetailsService,
    private userService: UserService,

  ) {
    super();
  }

  ngOnInit(): void {
    this.authorizationsForm = this.fb.group({
        firstName: [[]],
        lastName: [[]],
        medicaid: [[]],
        pplId: [[]],
        plAuthNumber: [[]],
        clientAuthNumber: [[]],
        hcpcsServiceCode: [[]],
        modifier1: [null],
        modifier2: [null],
        modifier3: [null],
        modifier4: [null],
        units: [[]],
        dollars: [[]],
        authStartDate: [[]],
        authEndDate: [[]],
        mcoId: [[]],
    });

    const program = this.userService.getSelectedProgram();
    this.flow = this.sectionsService.getFlow() ?? '';
    this.programName = program?.program_code ?? '';
    this.secData = this.sectionsService.getSectionData(
      program?.program_code,
      'payroll'
    );
    this.providerTypes = this.getLookup('ProviderType');
    // this.lookupService.getDiagnosisLookupValues().subscribe((data: any) => {
    //   console.log('data', data.responsedata);
    //   this.diagnosisCodesList = data.responsedata;
    // });
    this.getGridHeaders();

  }

  returnClicked() {
    console.log('going back from process codes');
    this.router.navigate(['/home/authorizations']);
  }
  
  goBack() {
    this.authorizationService.setDocUpload(false);
    this.router.navigate(['/home/authorizations']);
  }
  authSubmitted(event: any) {
    this.show = true;
  }

  onEdit() {
    this.mode = 'edit';
    //patch form here;
  }

  onConsumerSearch() {
    this.showConsumersList = true;
  }

  handleOk(){
    this.authAdded = true;
    this.show = false;
    this.authorizationService.setDocUpload(true);
  }

  async getGridHeaders() {
    try {
        if(this.flow) {
        const tempCols = await this.sectionsService.getJsonConfigurationData(STATIC_JSON_DATA_PATH.AUTHORIZATIONS_CONSUMER_LIST_HEADERS, this.flow);
        console.log(tempCols.columns);
        this.cols = tempCols.columns;
        }
    } catch {
      throw new Error(`Failed to get headers`)
    }

  }

  action(event: GridAction) {
    if (event && event.action === 'add') {
        console.log(event.data);
        this.selectedConsumer = event.data;
        this.isConsumerSelected = true;
        this.showConsumersList = false;
    }

  }

  onAdd() {
    console.log('Adding!!');
    this.mode = 'read';
  }

  onCancel() {
    this.mode = 'read';
    this.validationErrors = {};
    this.authorizationsForm.reset();
  }

  onUpdate() {
    console.log('Updating!!');
  }

  viewerValueChange(value: string) {
    const viewerValue = [value][0];
    this.isParticipantSelected = true;
  }

  addMore(){
    this.mode = 'edit';
    this.isConsumerSelected = false;
  }
}
